const THEME_NAME_MAP: Record<string, string> = {
    template_default: 'defaultTemplate',
    template_dark: 'darkTemplate',
    template_red: 'redTemplate',
    template_sky_blue: 'skyBlueTemplate',
    template_grey: 'greyTemplate',
    template_gold_black: 'goldBlackTemplate',
    template_beige: 'beigeTemplate'
}

export const getThemeHref = (themeValue: string, basePath: string): string | undefined => {
    const themeName = THEME_NAME_MAP[themeValue]
    if (!themeName) {
        return undefined
    }
    return `${basePath}/theme/${themeName}.css`
}

export default getThemeHref
